export default "__VITE_ASSET__izf7V6wl__"